export default "__VITE_ASSET__BJYITzF2__"